import { INITIAL_FRAME_OFFSET, toKeyframeValue } from '../../utils';
const DIRECTION_TO_TRANSFORM_MAP = {
  top: {
    rotateX: 80
  },
  right: {
    rotateY: 80
  },
  bottom: {
    rotateX: -80
  },
  left: {
    rotateY: -80
  }
};
const EASING_MAP = {
  soft: 'cubicInOut',
  medium: 'quintInOut',
  hard: 'backOut'
};
export function web(options, dom) {
  prepare(options, dom);
  return style(options, true);
}
export function getNames(_) {
  return ['motion-fadeIn', 'motion-arcIn'];
}
export function style(options, asWeb) {
  if (asWeb === void 0) {
    asWeb = false;
  }
  const {
    power,
    direction = 'right'
  } = options.namedEffect;
  const [fadeIn, arcIn] = getNames(options);
  const easing = power && EASING_MAP[power] || options.easing || 'quintInOut';

  // we can remove dependency on measurement here if we use a "layout wrapper" as a `container`: https://jsbin.com/mulojuwogi/edit?css,output
  // we could also consider a fixed value for z, e.g. 300px like in ArcScroll
  // const { width, height } = element.getBoundingClientRect();

  const {
    rotateX,
    rotateY
  } = DIRECTION_TO_TRANSFORM_MAP[direction];
  // const z = rotateX ? height / 2 : width / 2;
  const z = `(-1 * var(${rotateX ? '--motion-height' : '--motion-width'}, 100v${rotateX ? 'h' : 'w'}) / 2)`;
  const custom = {
    '--motion-translate-z': z,
    '--motion-arc-rotation': `rotateX(${rotateX || 0}deg) rotateY(${rotateY || 0}deg)`
  };
  const transZ = toKeyframeValue(custom, '--motion-translate-z', asWeb);
  return [{
    ...options,
    name: fadeIn,
    duration: options.duration * 0.7,
    easing: 'sineIn',
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...options,
    name: arcIn,
    easing,
    custom,
    keyframes: [{
      offset: INITIAL_FRAME_OFFSET,
      transform: `perspective(800px) translateZ(calc${transZ}) ${toKeyframeValue(custom, '--motion-arc-rotation', asWeb)} translateZ(calc(-1 * ${transZ})) rotate(var(--comp-rotate-z, 0deg))`
    }, {
      transform: `perspective(800px) translateZ(calc${transZ}) rotateX(0deg) rotateY(0deg) translateZ(calc(-1 * ${transZ})) rotate(var(--comp-rotate-z, 0deg))`
    }]
  }];
}
export function prepare(options, dom) {
  const {
    direction = 'right'
  } = options.namedEffect;
  const isVertical = direction === 'top' || direction === 'bottom';
  if (dom) {
    let width, height;
    dom.measure(target => {
      if (!target) {
        return;
      }
      const rect = target.getBoundingClientRect();
      width = rect.width;
      height = rect.height;
    });
    dom.mutate(target => {
      if (isVertical) {
        target == null || target.style.setProperty('--motion-height', `${height}px`);
      } else {
        target == null || target.style.setProperty('--motion-width', `${width}px`);
      }
    });
  }
}
//# sourceMappingURL=ArcIn.js.map